import gql from "graphql-tag";
import { taskFileTypeDef } from "../definitions/task-file-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const uploadTaskFileMutation = gql`
  mutation taskFileUpload (
  $taskId: String!
  $taskFileGroupId: String
  $name: String!
  $content: String!
  $extension: String!
  ) {
    taskFile{
      upload(input: {
        taskId: $taskId
        taskFileGroupId: $taskFileGroupId
        file: {
          name: $name
          content: $content
          extension: $extension
        }
      }) {
        output {
          ${taskFileTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default uploadTaskFileMutation;
